import React, { useEffect, useState } from 'react';
import "@arco-design/web-react/dist/css/arco.css";
import { MdCatalog, MdPreview } from 'md-editor-rt';
import 'md-editor-rt/lib/style.css';
import './App.css';
import { Card, Skeleton, Tag } from '@arco-design/web-react';
import { IconCalendarClock, IconEye, IconUser } from '@arco-design/web-react/icon';

import axios from 'axios';

const scrollElement = document.documentElement;
function App() {
  const [id, setId] = React.useState<string>("");
  const [load, setLoad] = React.useState<boolean>(false);
  const [show, setShow] = React.useState<boolean>(false);
  const [mdText, setMdText] = React.useState<string>("");
  const [Title, setTitle] = React.useState<string>("");
  const [author, setAuthor] = React.useState<string>("");
  const [pv, setPv] = React.useState<number>(0);
  const [releTime, setReleTime] = React.useState<string>("");
  const [mdId] = useState('preview-only');



  useEffect(() => {

    var uid = urlID()
    setId(uid)

    if (uid && load) {
      axios.get('/web-api/article?id=' + uid)
        .then(res => {
          var data = res.data.data
          console.log(data)
          setMdText(data.details)
          setTitle(data.title)
          setReleTime(data.release_time)
          setAuthor(data.author)
          setPv(data.pv)
          setLoad(true)
          setShow(true)
        })
      // axios.get('/web-api/page?id=' + uid)
      //   .then(res => {
      //     setMdText(res.data.data)
      //     setTitle(res.data.msg)
      //     setLoad(true)
      //     setShow(true)
      //   })
    }
    setLoad(true)

  }, [load]);

  const urlID = () => {
    const url = window.location.pathname;
    let path = url.replace(/^https?:\/\//, '');
    path = path.split('?')[0].split('#')[0];
    path = path.replace(/\.[^/.]+$/, '');
    const parts = path.split('/');
    return parts[parts.length - 1]
  }

  return (
    <div className='row' style={{ position: "relative", display: "flex" }}>
      <div className="catalog col-md-3">
        <div className='lf-row'>
          <MdCatalog editorId={mdId} scrollElement={scrollElement} style={{ backgroundColor: "#fff", borderRadius: "8px", padding: "30px 15px", boxShadow: "0 10px 30px 0 rgb(62 61 80 / 3%)" }} />
        </div>
      </div>
      <div className='col-md-9'>
        <Card className="details_card" style={{ width: "100%" }} bordered={false}>
          <div className="title_box" style={{ paddingBottom: "18px", paddingLeft: "25px", borderBottom: "1px solid #ccc" }}>
            <div className='title'>{Title}</div>
            <div className='bot-row'>
              <div>
                 <Tag color={"blue"} style={{ margin: '0 16px 16px 0 ' }}>
                 <IconCalendarClock /> {releTime}
                </Tag>
              </div>

              <div><Tag color={"green"} style={{ margin: '0 16px 16px 0 ' }}>
              <IconUser /> {author}
              </Tag></div>

              <div><Tag color={"green"} style={{ margin: '0 16px 16px 0 ' }}>
              <IconEye />{pv}
              </Tag></div>
            </div>
          </div>
          {show ? <MdPreview editorId={mdId} modelValue={mdText} ></MdPreview> : <Skeleton></Skeleton>}

        </Card>

      </div>

    </div>
  );
}

export default App;
